import { render, staticRenderFns } from "./ict.vue?vue&type=template&id=58b8f4ac&scoped=true&"
import script from "./ict.vue?vue&type=script&lang=js&"
export * from "./ict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b8f4ac",
  null
  
)

export default component.exports